import type { Client } from "@zeller-public/payments-sdk-core";

import { Route } from "./shared/route";
import { RefundMatched } from "./terminal-refund/refund-matched";
import { RefundUnmatched } from "./terminal-refund/refund-unmatched";

export type RefundMatchedRequest = Route.Request<"Terminal_refund"> & {
	query: Client.refund_Options & Client.refund_Options.Matched;
};

export type RefundUnmatchedRequest = Route.Request<"Terminal_refund"> & {
	query: Client.refund_Options & Client.refund_Options.Unmatched;
};

// eslint-disable-next-line react-refresh/only-export-components
export default Route({ query: "Terminal_refund" }, function (request) {
	if (isUnmatchedRequest(request)) {
		return <RefundUnmatched request={request} />;
	}

	return <RefundMatched request={request as unknown as RefundMatchedRequest} />;
});

function isUnmatchedRequest(
	req: Route.Request<"Terminal_refund">,
): req is RefundUnmatchedRequest {
	return "cardPresent" in req.query && req.query.cardPresent === true;
}
